import {IRoutableModule} from '../../router/routing.infra';
import {joinRouteLoader} from './join.loader';

export default {
    loader: joinRouteLoader,
    Component: () => null,
    storeAs: 'joinStore'
} as IRoutableModule;
